/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantHealthFax
 */
export interface TenantHealthFax {
    /**
     * 
     * @type {number}
     * @memberof TenantHealthFax
     */
    sent_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthFax
     */
    failed_7d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthFax
     */
    sent_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthFax
     */
    failed_30d?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthFax
     */
    queued?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantHealthFax
     */
    sending?: number;
}

/**
 * Check if a given object implements the TenantHealthFax interface.
 */
export function instanceOfTenantHealthFax(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantHealthFaxFromJSON(json: any): TenantHealthFax {
    return TenantHealthFaxFromJSONTyped(json, false);
}

export function TenantHealthFaxFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantHealthFax {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sent_7d': !exists(json, 'sent_7d') ? undefined : json['sent_7d'],
        'failed_7d': !exists(json, 'failed_7d') ? undefined : json['failed_7d'],
        'sent_30d': !exists(json, 'sent_30d') ? undefined : json['sent_30d'],
        'failed_30d': !exists(json, 'failed_30d') ? undefined : json['failed_30d'],
        'queued': !exists(json, 'queued') ? undefined : json['queued'],
        'sending': !exists(json, 'sending') ? undefined : json['sending'],
    };
}

export function TenantHealthFaxToJSON(value?: TenantHealthFax | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sent_7d': value.sent_7d,
        'failed_7d': value.failed_7d,
        'sent_30d': value.sent_30d,
        'failed_30d': value.failed_30d,
        'queued': value.queued,
        'sending': value.sending,
    };
}

